import { configureStore } from '@reduxjs/toolkit'
import headerSlice from '../features/common/headerSlice'
import modalSlice from '../features/common/modalSlice'
import rightDrawerSlice from '../features/common/rightDrawerSlice'
import studentClassesSlice from '../features/student-classes/studentClassesSlice'
import { apiSlice } from './apiSlice';
import { setupListeners } from '@reduxjs/toolkit/query'

const combinedReducer = {
  header : headerSlice,
  rightDrawer : rightDrawerSlice,
  modal : modalSlice,
  studentClasses : studentClassesSlice,
  [apiSlice.reducerPath]: apiSlice.reducer,
}

const store = configureStore({
  reducer: combinedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(apiSlice.middleware), // Add the API middleware
});

setupListeners(store.dispatch);
export default store;